import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import beeyLogo from 'resources/img/product-logo.svg';
import { useAppSubdomain } from 'hooks/useAppSubdomain';
import styles from './style.module.less';
const Brand = () => {
    const { pageTitle, subtitle, isSubdomain } = useAppSubdomain();
    const chooseLogo = () => {
        if (isSubdomain) {
            return (_jsxs("div", { className: styles.subdomain, children: [_jsx("span", { className: styles.subdomainTitle, children: pageTitle.toUpperCase() }), _jsx("span", { className: styles.subdomainSubtitle, children: subtitle })] }));
        }
        return _jsx("img", { className: styles.beeyLogo, alt: "Beey logo", src: beeyLogo });
    };
    return (_jsx("a", { href: "/projects", children: chooseLogo() }));
};
export default Brand;
